import { BoxProps, Center, Flex, Icon, Text, WrapItem } from "@chakra-ui/react";
import { As } from "@chakra-ui/system";

interface Props extends BoxProps {
  title: string;
  icon: As;
  readonly?: boolean;
  externalHref?: string;
}

function AppTileSelf(props: Props) {
  const { title, icon, readonly = false, color, bgColor, onClick, ...rest } = props;
  return (
    <WrapItem>
      <Center
        flexDirection="column"
        w={52}
        h={52}
        cursor={readonly ? "not-allowed" : "pointer"}
        margin={6}
        borderRadius={2.5 * 4}
        justifyContent="center"
        color={readonly ? "gray.400" : color}
        bgColor={readonly ? "gray.100" : bgColor}
        _hover={
          readonly
            ? undefined
            : {
                transform: "scale(1.03)",
                boxShadow: "2px 2px 10px #b9b9b9",
              }
        }
        onClick={readonly ? undefined : onClick}
        p={2}
        {...rest}
        position="relative"
      >
        <Icon as={icon} mb={4} fill={readonly ? "gray.400" : color} w={16} h={16} />
        <Flex alignItems="flex-start" justifyContent="center">
          <Text fontSize={18} fontWeight="bold" textAlign="center">
            {title}
          </Text>
        </Flex>
      </Center>
    </WrapItem>
  );
}

export function AppTile(props: Props) {
  const { externalHref } = props;

  if (externalHref)
    return (
      <a rel="stylesheet noreferrer" href={externalHref} target="_blank">
        <AppTileSelf {...props} />
      </a>
    );

  return <AppTileSelf {...props} />;
}

export default AppTile;
